import { isNavigableZzjUrl } from "web_myplann/NotificationCenter/Utils/isNavigableZzjUrl";
import type { ClientActionData } from "web_myplann/NotificationCenter/Utils/parseClientActionData";

const isZzjInProgress = (status: string | null | undefined): boolean => {
	if (status == null) {
		return true;
	}
	return status.replace(/[_\s-]/g, "").toLowerCase() === "inprogress";
};

export const getZzjBridgeUrl = (data: ClientActionData): string | null =>
	isZzjInProgress(data.status) && isNavigableZzjUrl(data.url) ? data.url : null;
